import * as React from 'react';
import * as Styled from './DashboardEditGuide.styled';
export const DashboardEditGuide = (props) => {
    const { height, config } = props;
    const guide = [];
    for (let i = 0; i < height; i++) {
        for (let j = 0; j < config.columnCount; j++) {
            guide.push(React.createElement(Styled.Guide, Object.assign({ key: i + j }, config, { top: i, left: j })));
        }
    }
    return React.createElement(React.Fragment, null, guide);
};
//# sourceMappingURL=DashboardEditGuide.js.map